import Vue from 'vue'
import Lang from 'vue-lang'
import config from '../config'
import ky from '../locales/ky'
import ru from '../locales/ru'

let locales = {
    ky,
    ru
};
// Проверям если в localStorage есть locale
let language = localStorage.getItem('locale');

if (typeof locales[language] === 'undefined') language = config.locale;

Vue.use(Lang, {lang: language, locales: locales});